// frontend/src/components/Members/EditMember.tsx
import React, { useState, useEffect } from "react";
import axios from "axios";
import styles from "./EditMember.module.css";

export default function EditMember({
  member,
  onClose,
  onSaved,
  isSuperAdmin,
}: any) {
  const API = process.env.REACT_APP_API_URL || "http://localhost:8080";
  const token = localStorage.getItem("bni_token") || "";
  const [form, setForm] = useState<any>({});
  const [keywordText, setKeywordText] = useState("");

  useEffect(() => {
    setForm(member || {});
    setKeywordText(member?.keywords?.join(", ") || "");
  }, [member]);

  const update = (key: string, value: any) => {
    setForm({ ...form, [key]: value });
  };

  const onKeywordsChange = (e: any) => {
    const text = e.target.value;
    setKeywordText(text);

    const arr = text
      .split(",")
      .map((k: string) => k.trim())
      .filter((k: string) => k.length > 0);

    update("keywords", arr);
  };

  const submit = async (e: any) => {
    e.preventDefault();

    try {
      await axios.put(`${API}/api/members/${form._id}`, form, {
        headers: { Authorization: "Bearer " + token },
      });

      alert("✅ Member updated successfully!");
      onSaved && onSaved();
      onClose();
    } catch (err) {
      console.error("Update failed:", err);
      alert("❌ Failed to update member.");
    }
  };

  if (!form || !member) return null;

  return (
    <div className={styles.modalBackdrop}>
      <div className={styles.modalCard}>
        {/* HEADER */}
        <div className={styles.modalHeader}>
          Edit Member
          <button className={styles.closeBtn} onClick={onClose}>
            ✖
          </button>
        </div>

        <form className={styles.form} onSubmit={submit}>
          {/* PROFILE PREVIEW */}
          {form.userImage && (
            <img
              src={form.userImage}
              alt="profile"
              className={styles.avatarPreview}
            />
          )}

          <div className={styles.sectionTitle}>Basic Information</div>

          <div className={styles.row}>
            <label>Name</label>
            <input
              value={form.name || ""}
              onChange={(e) => update("name", e.target.value)}
              required
            />
          </div>

          <div className={styles.row}>
            <label>Email</label>
            <input
              value={form.email || ""}
              onChange={(e) => update("email", e.target.value)}
            />
          </div>

          <div className={styles.row}>
            <label>Contact No</label>
            <input
              value={form.contactNo || ""}
              onChange={(e) => update("contactNo", e.target.value)}
            />
          </div>

          <div className={styles.row}>
            <label>WhatsApp No</label>
            <input
              value={form.whatsappNo || ""}
              onChange={(e) => update("whatsappNo", e.target.value)}
            />
          </div>

          {/* COMPANY INFO */}
          <div className={styles.sectionTitle}>Company Details</div>

          <div className={styles.row}>
            <label>Organisation Name</label>
            <input
              value={form.orgName || ""}
              onChange={(e) => update("orgName", e.target.value)}
            />
          </div>

          <div className={styles.row}>
            <label>Website</label>
            <input
              value={form.website || ""}
              onChange={(e) => update("website", e.target.value)}
            />
          </div>

          <div className={styles.row}>
            <label>Address</label>
            <input
              value={form.address || ""}
              onChange={(e) => update("address", e.target.value)}
            />
          </div>

          <div className={styles.row}>
            <label>Company Details</label>
            <textarea
              value={form.companyDetails || ""}
              onChange={(e) => update("companyDetails", e.target.value)}
            />
          </div>

          {/* SOCIAL LINKS */}
          <div className={styles.sectionTitle}>Social Handles</div>

          <div className={styles.row}>
            <label>Facebook</label>
            <input
              value={form.socialHandles?.facebook || ""}
              onChange={(e) =>
                update("socialHandles", {
                  ...form.socialHandles,
                  facebook: e.target.value,
                })
              }
            />
          </div>

          <div className={styles.row}>
            <label>Instagram</label>
            <input
              value={form.socialHandles?.instagram || ""}
              onChange={(e) =>
                update("socialHandles", {
                  ...form.socialHandles,
                  instagram: e.target.value,
                })
              }
            />
          </div>

          <div className={styles.row}>
            <label>LinkedIn</label>
            <input
              value={form.socialHandles?.linkedin || ""}
              onChange={(e) =>
                update("socialHandles", {
                  ...form.socialHandles,
                  linkedin: e.target.value,
                })
              }
            />
          </div>

          {/* BIO */}
          <div className={styles.sectionTitle}>Bio</div>

          <div className={styles.row}>
            <label>Personal Bio</label>
            <textarea
              value={form.bio || ""}
              onChange={(e) => update("bio", e.target.value)}
            />
          </div>

          <div className={styles.row}>
            <label>Organisation Bio</label>
            <textarea
              value={form.orgBio || ""}
              onChange={(e) => update("orgBio", e.target.value)}
            />
          </div>

          {/* ADMIN CONTROLS */}
          {isSuperAdmin && (
            <>
              <div className={styles.sectionTitle}>Admin Controls</div>

              <div className={styles.row}>
                <label>BNI Role</label>
                <select
                  value={form?.memberType || "Member"}
                  onChange={(e) => update("memberType", e.target.value)}
                >
                  <option value="President">President</option>
                  <option value="Vice President">Vice President</option>
                  <option value="Secretary Treasurer">
                    Secretary Treasurer
                  </option>
                  <option value="Member">Member</option>
                  <option value="Leadership">Leadership</option>
                </select>
              </div>

              <div className={styles.sectionTitle}>Keywords</div>

              <div className={styles.row}>
                <label>Keywords (comma separated)</label>

                <input
                  value={keywordText}
                  onChange={onKeywordsChange}
                  placeholder="steel, furnace, blast furnace"
                />
              </div>
            </>
          )}

          {/* FOOTER */}
          <div className={styles.modalFooter}>
            <button className={styles.saveBtn} type="submit">
              💾 Save Changes
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
